import { withJsonFormsControlProps } from "@jsonforms/react";
import SelectMultiple from "../SelectMultiple";
import { CustomRendererProps } from "../types";
import { print } from "graphql";
import { gql } from "@apollo/client";
import { ApiCMSRequest, responseApiCMSRequest } from "data/ApiCMS";
import ModalBlogPostsSelect from "components/CRPComponents/ModalBlogPostsSelect";

const query = print(gql`
  query Blog($id: Int!) {
    Blog(id: $id) {
      title
      id
    }
  }
`);
interface ItemGql {
  Blog: {
    title: string;
    id: number;
  };
}

const BlogPostsSelectMultiple = (props: CustomRendererProps<number[] | undefined>) => {
  return (
    <SelectMultiple
      {...props}
      Modal={ModalBlogPostsSelect}
      formatItem={({ data }: responseApiCMSRequest<ItemGql>) => ({
        ...data.data.Blog,
        name: data.data.Blog.title,
      })}
      requestItem={(id: number) => ApiCMSRequest<ItemGql>({ query, variables: { id } })}
    />
  );
};

export default withJsonFormsControlProps(BlogPostsSelectMultiple, false);
